
  import { Component, Prop, Vue } from "vue-property-decorator";
  import GET_CONTRACTOR_DOCUMENT_ATTACHMENTS from "@/apollo/documents/GetContractorDocumentAttachments.gql";
  import { Document, User } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";
  import DocumentAttachedTo from "@/entities/document/DocumentAttachedTo";
  import getAttachedDocToApplicationsQuery from "@/helpers/customBreadcrumbQueries/AttachedDocToApplicationQuery";

  @Component({
    apollo: {
      documentDetails: {
        query: GET_CONTRACTOR_DOCUMENT_ATTACHMENTS,
        variables() {
          return {
            documentId: this.document.id,
          };
        },
        update(data) {
          return data.document_by_pk;
        },
      },
    },
  })
  export default class ContractorDocumentInfoProvider extends Vue {
    @Prop({ type: Object, required: true }) readonly document!: Document;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    documentDetails: Document | null = null;

    get processing(): boolean {
      return this.$apollo.queries.documentDetails.loading;
    }

    get applications(): DocumentAttachedTo {
      const applicationsCount = this.documentDetails!.applications.length;
      if (applicationsCount === 0) {
        return {
          id: "",
          details: [],
        };
      }

      const desc = applicationsCount === 1 ? "application" : "applications";

      return {
        id: "applications",
        details: [{
          value: `${applicationsCount} ${desc}`,
          routeParams: {
            name: RouteNames.JOBBOARD_APPLICATIONS,
            query: getAttachedDocToApplicationsQuery(this.document),
          },
        }]
      }

    }

    get attachedToEntities(): DocumentAttachedTo[] {
      if (this.processing) {
        return [];
      }

      return [
        this.applications,
      ].filter(entity => entity.details.length > 0);
    }
  }
